import React from 'react';

// Barra de busca padrão (mesmo estilo da aba Telemetria/Pagamentos)
export const SearchBar = ({ value, onChange, placeholder = 'Buscar...', testId = 'busca-input', resultado }) => (
  <div className="w-full">
    <div className="relative w-full lg:w-80">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm pointer-events-none">🔎</span>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-9 pr-9 py-2 bg-slate-900/70 border border-white/10 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/60 focus:ring-1 focus:ring-blue-500/40 transition-all"
        data-testid={testId}
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-white/10 text-sm"
          data-testid={`${testId}-limpar`}
          title="Limpar busca"
        >
          ×
        </button>
      )}
    </div>
    {value && resultado !== undefined && (
      <div className="mt-2 text-xs text-gray-400" data-testid={`${testId}-resultado`}>
        {resultado === 0 ? 'Nenhum resultado encontrado.' : `${resultado} resultado${resultado > 1 ? 's' : ''} para "${value}"`}
      </div>
    )}
  </div>
);
